
const bands = [
  [0, 22847.76, 0],
  [22847.77, 33919.8, 0.075],
  [33919.81, 45012.6, 0.15],
  [45012.61, 55976.16, 0.225],
  [55976.17, Infinity, 0.275],
];

export const getIncomeTaxValue = (incomeTaxBaseValue) => {
  const bandsValues = bands.map(([min, max, rate]) => {
    if (incomeTaxBaseValue < min) {
      return 0;
    }
    if (incomeTaxBaseValue >= max) {
      return (max - min) * rate;
    } else {
      return (incomeTaxBaseValue - min) * rate;
    }
  });
  return bandsValues.reduce((p, c) => {
    return p + c;
  }, 0);
};

export const exemptLimit = bands[0][1]

